import React, { useState,useEffect  } from 'react';
import { useDescope } from '@descope/react-sdk';
import { LoginForm } from './UIComponents';
import { useCookies } from 'react-cookie';


function LoginFormComponent({ setLoggedIn }) {
  const descopeSdk = useDescope();
  const [errorMessage, setErrorMessage] = useState(null);
  const [infoMessage, setInfomessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [cookies, setCookie] = useCookies(['userEmail', 'version']);



  function getQueryParam(url, param) {
    const urlParams = new URLSearchParams(new URL(url).search);
    return urlParams.get(param);
  }
  const [email, setEmail] = useState('');
  const [showSessionInfo, setShowSessionInfo] = useState(false);
  
  useEffect(() => {
    const savedEmail = cookies?.userEmail;
    if (savedEmail) {
      setEmail(savedEmail);
      setShowSessionInfo(true); 
    }
  }, []);
  
  
  

  const handleLoginClick = async () => {
    const personalDomains = ['gmail.com', 'yahoo.com', 'outlook.com', 'icloud.com', 'aol.com'];
    const domain = email.split('@')[1];
    if (personalDomains.includes(domain)) {
      setErrorMessage("Please use your organization email address.");
      return;
    }

    if (!email || isLoading) return;
    setIsLoading(true);
    
    //const redirectURL = 'http://localhost:3000?callback=keyrunner://auth/callback&version=desktop';
    const providedURL = window.location.href;
    const redirectUri = getQueryParam(providedURL, 'redirect_uri');
    const version = getQueryParam(providedURL, 'version');
    if (!version) {
      setErrorMessage("Version parameter not found in URL");
      setIsLoading(false);
      return;
    }
    const redirectURL = `https://identity.keyrunner.app/?callback=${encodeURIComponent(redirectUri)}&version=${encodeURIComponent(version)}`;
    //const redirectURL = `http://localhost:3000?callback=${encodeURIComponent(redirectUri)}&version=${encodeURIComponent(version)}`;

    const loginOptions = {
      stepup: false,
      mfa: false,
      customClaims: { claim: 'Value1' },
      templateOptions: { option: 'Value1' },
    };

    try {
      const resp = await descopeSdk.saml.start(email, redirectURL, loginOptions);
      if (!resp.ok) {
        const errorMessage = resp.data.errorMessage; 
        setErrorMessage(errorMessage);
        setIsLoading(false);
      } else {
        const url = resp.data.url;
        window.location.href = url;
        const version = getQueryParam(providedURL, 'version');
        const userEmail = decodeURIComponent(email);

        setCookie('userEmail', userEmail, { path: '/', maxAge: 30 * 24 * 60 * 60 });
        setCookie('version', version, { path: '/', maxAge: 30 * 24 * 60 * 60 });
      }
    } catch (error) {
      console.warn("SSO failed, trying magic link instead:", error.message);
      try {
        const loginOptions = {
          stepup: false,
          mfa: false,
          customClaims: { claim: 'Value1' },
          templateOptions: { option: 'Value1' },
        };
    
        const resp = await descopeSdk.magicLink.signIn.email(email, redirectURL, loginOptions);
    
        if (!resp.ok) {
          console.error("Magic link failed:", resp.error?.errorMessage);
          setErrorMessage("Login failed via SSO and Magic Link.");
          setInfomessage(" Reach out to us at contact@keyrunner.app to request a demo account.");
        } else {
          setInfomessage("Your organization is not yet onboarded for SSO. A magic link has been sent to your email.");
        }
      } catch (magicError) {
        console.error("Magic link exception:", magicError.message);
        setErrorMessage("Login failed via both SSO and Magic Link.");
      }finally {
        setIsLoading(false);
      }
    }    
    
  };
     return (
      <LoginForm email={email} setEmail={setEmail} showSessionInfo={showSessionInfo} setShowSessionInfo={setShowSessionInfo} setCookie={setCookie}
      autoComplete="username" handleLoginClick={handleLoginClick} errorMessage={errorMessage} infoMessage={infoMessage}  isLoading={isLoading}/>
    );
}

export default LoginFormComponent;
